import { InputForm, SubmitButton, Error, Textarea } from "components";
import { CreateMembershipDurationInput, CreateMembershipDurationError } from "../../../store/actionType";
interface FormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: CreateMembershipDurationInput;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error: CreateMembershipDurationError;
  loading: boolean;
  header:string;
}
const MembershipDurationForm: React.FC<FormProps> = ({
  formData,
  handleChange,
  error,
  loading,
  handleSave,
  header
}) => {
  return (
    <section className="w-full flex flex-col items-center justify-center p-4">
      <form className="w-full max-w-screen-md">
        <h2 className="text-2xl font-bold text-center mb-4">{header}</h2>
        <div className="grid grid-cols-1 gap-3">
          <div>
            <InputForm
              label="Duration Type"
              type="text"
              id="duration_type"
              name="duration_type"
              value={formData.duration_type}
              onChange={handleChange}
            />
            {error.duration_type && <Error>{error.duration_type}</Error>}
          </div>
          <div>
            <InputForm
              label="Number of Days"
              type="number"
              id="number_of_days"
              name="number_of_days"
              value={formData.number_of_days}
              onChange={handleChange}
            />
            {error.number_of_days && <Error>{error.number_of_days}</Error>}
          </div>
          <div>
            <InputForm
              label="Price BTN"
              type="number"
              id="price"
              name="price"
              value={formData.price}
              onChange={handleChange}
            />
            {error.price && <Error>{error.price}</Error>}
          </div>
          <div>
            <InputForm
              label="Price USD"
              type="number"
              id="price_usd"
              name="price_usd"
              value={formData.price_usd}
              onChange={handleChange}
            />
            {error.price_usd && <Error>{error.price_usd}</Error>}
          </div>
          <div>
            <Textarea
              label="Description"
              id="description"
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
            {error.description && <Error>{error.description}</Error>}
          </div>
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </section>
  );
};
export default MembershipDurationForm;
